import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	cdExceptions: ["exceptions"],
	cdExceptionsClean: [],
	cdExceptionsUpdate: ['response'],
	cdExceptionsAdd: ["exception"],
	cdCleanExceptionsAdd: [],
	cdExceptionsCleanAll: [],
	setExceptionsError:[''],
	setExceptionsSuccess:['']
});

//Reducer Handlers
const INITIAL_STATE = {
	cdExceptions: null,
	cdExceptionsUpdate: null,
	cdExceptionsAdd: {
		idCd: null,
		data: null,
		descricao: null
	},
	cdExceptionsError: [],
	cdExceptionsSuccess: []
};

const cdExceptions = (state = INITIAL_STATE, action) => {
	return { ...state, cdExceptions: action.payload }
};

const cdExceptionsUpdate = (state = INITIAL_STATE, action) => {
	return { ...state, cdExceptionsUpdate: action.payload }
};

const cleanCdExceptions = (state = INITIAL_STATE, action) => {
	return { ...state, cdExceptions: null }
};

const cdExceptionsAdd = (state = INITIAL_STATE, action) => {
    return {
		...state, cdExceptionsAdd: {
			idCd: action.idCd,
			data: action.data,
			descricao: action.descricao
		}
	}
};

const cdCleanExceptionsAdd = (state = INITIAL_STATE, action) => {
	return {
		...state, cdExceptionsAdd: {
			idCd: null,
			data: null,
			descricao: null
		}
	}
};

const setExceptionError = (state = INITIAL_STATE, action) => {
	return {
		...state, 
		cdExceptionsError: {
			...action.payload
		}
	}
};

const setExceptionSuccess = (state = INITIAL_STATE, action) => {
	return {
		...state, 
		cdExceptionsSuccess: {
			...action.payload
		}
	}
};

const cleanAll = (state = INITIAL_STATE, action) =>
	INITIAL_STATE

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.CD_EXCEPTIONS]: cdExceptions,
	[Types.CD_EXCEPTIONS_UPDATE]: cdExceptionsUpdate,
	[Types.CD_EXCEPTIONS_CLEAN]: cleanCdExceptions,
	[Types.CD_EXCEPTIONS_ADD]: cdExceptionsAdd,
	[Types.CD_CLEAN_EXCEPTIONS_ADD]: cdCleanExceptionsAdd,
	[Types.CD_EXCEPTIONS_CLEAN_ALL]: cleanAll,
	[Types.SET_EXCEPTIONS_ERROR]: setExceptionError,
	[Types.SET_EXCEPTIONS_SUCCESS]: setExceptionSuccess
});
